import { CustomDialog } from '../../../../components/CustomDialog';
import { useState } from 'react';
import {
  Button,
  DatePickerController,
} from '../../../../components';
import { downLoadLink } from '../../../../utils/functions/common';
import { useAppDispatch } from '../../../../storeHook';
import { showAlert } from '../../../../services/alert';
import { useLazyGetSettlementReportQuery } from '../../../../services/paymentsDashboard';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import './index.scss';

export const formSchema = yup.object({
  startDate: yup.date().required('Start Date is required'),
  endDate: yup.date().required('End Date is required'),
});

export type TFilterForm = yup.InferType<typeof formSchema>;

export const SettlementReport: React.FC<{
  enterpriseId: number;
}> = ({ enterpriseId }) => {
  const dispatch = useAppDispatch();
  const [getSettlementReport] =
    useLazyGetSettlementReportQuery();
  const [open, setOpen] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm<TFilterForm>({
    mode: 'onTouched',
  });

  const onDownloadClick = (data: TFilterForm) => {
    getSettlementReport({
      startDate: data.startDate
        ? dayjs(data.startDate).format('DD-MM-YYYY')
        : '',
      endDate: data.endDate
        ? dayjs(data.endDate).format('DD-MM-YYYY')
        : '',
      enterpriseId,
    })
      .unwrap()
      .then((res) => {
        if (res.url) {
          downLoadLink(res.url);
          dispatch(
            showAlert({
              content:
                'Settlement Report Exported successfully',
            })
          );
        } else {
          dispatch(
            showAlert({
              severity: 'error',
              content: 'No records found',
            })
          );
        }
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-3"
        variant="button--secondary">
        Settlement Report
      </Button>
      <CustomDialog
        dialogTitle="Settlement Report"
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit(onDownloadClick)}
        actionText={{
          submit: 'Download',
          cancel: 'Cancel',
        }}
        maxWidth="sm">
        <div>
          <div className="report-description mt-3">
            This report will give detailed data on payments
            settled to you and will have information on UTR,
            Invoice, Order and settlement breakup.
          </div>
          <form className="grid grid-cols-2 gap-10 mt-3">
            <DatePickerController
              label="Payment start Date"
              control={control}
              name="startDate"
              error={errors.startDate?.message}
              selectsStart
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
            <DatePickerController
              label="Payment end Date"
              control={control}
              name="endDate"
              error={errors.endDate?.message}
              selectsEnd
              startDate={watch('startDate')}
              endDate={watch('endDate')}
            />
          </form>
          <div className="report-note my-2">
            *Report can be downloaded for any 31 days time
            period
          </div>
        </div>
      </CustomDialog>
    </div>
  );
};
